import React from 'react';
import styled from 'styled-components';

const Intro = styled.section`
  max-width: 720px;
  margin: 0 auto 1.25rem;
  padding: 0 0.5rem;
  text-align: center;
`;

const H1 = styled.h1`
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
  line-height: 1.25;
  ${(p) =>
    p.$oneLine
      ? `
    margin-bottom: 0.75rem;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: clamp(0.72rem, 2.6vw, 1.75rem);
    line-height: 1.2;
  `
      : ''}
`;

const Lead = styled.p`
  font-size: 1rem;
  color: var(--text-secondary);
  line-height: 1.55;
  margin: 0;
`;

/**
 * Visible SEO heading + intro copy for category/vertical landing pages.
 */
export default function SeoPageIntro({ h1, description, children, oneLine = false }) {
  if (!h1 && !description) return null;
  return (
    <Intro aria-label="Page introduction">
      {h1 ? <H1 $oneLine={oneLine}>{h1}</H1> : null}
      {description ? <Lead>{description}</Lead> : null}
      {children}
    </Intro>
  );
}
